/**
 * Type for the KPI change direction
 */
export type PhxKpiChangeType = 'positive' | 'negative' | 'no-change' | 'neutral';

export enum PhxKpiChangeTypeEnum {
  Positive = 'positive',
  Negative = 'negative',
  NoChange = 'no-change',
  Neutral = 'neutral',
}

export type PhxOverviewBackground = 'standard' | 'dark'

export type ChangeResponse = {
  changeValue: number;
  absoluteChangeValue: number;
  percentageChangeValue: number;
  changeType: PhxKpiChangeType;
};